/**
 * @requires ./frc.js
 */

frc.modules.ebites = function($form){
	var self = this;
	self.config = {};
	self.data = {
		"$form": $form,
		"enabled": true
	};

	self.init = function(){
		$('.form').attr("data-submitted", false);

		self.data.fields = {
			"name": self.data.$form.find("input[name=\"name\"]"),
			"email": self.data.$form.find("input[name=\"email\"]"),
			"birthMonth": self.data.$form.find("select[name=\"birthmonth\"]"),
			"birthDay": self.data.$form.find("select[name=\"birthday\"]"),
			"locations": self.data.$form.find("select[name=\"favoritelocations\"]"),
			"preferredLocation": self.data.$form.find("select[name=\"preferredlocation\"]"),
			"over21Checkbox": self.data.$form.find("input[name=\"over_21\"]"),
			"over21Label": self.data.$form.find("label[id=\"over_21_label\"]")
		};

		self.data.fields.over21Label.on("click", function(e) {
			self.data.fields.over21Checkbox.trigger("click");
		});

		self.data.fields.birthMonth.Selecta({ nativeOnMobile: true, validateOnSubmit: true, forceRenderBelow: true });
		self.data.fields.birthDay.Selecta({ nativeOnMobile: true, validateOnSubmit: true, forceRenderBelow: true });
		self.data.fields.locations.Selecta({ nativeOnMobile: true, validateOnSubmit: true, forceRenderBelow: true });
		self.data.fields.preferredLocation.Selecta({ nativeOnMobile: true, validateOnSubmit: true, forceRenderBelow: true });

		// Update birthDay dropdown to reflect birthMonth selection
		self.data.fields.birthMonth.on("selecta-change", function(evt, obj){
			var numMonth = $(this).val();
			var $option = self.data.fields.birthMonth.find("option[value=\"" + numMonth + "\"]");

			if($option.length) {
				var numDays = window.parseFloat($option.attr("data-num-days"));
				self.data.fields.birthMonth.prop('required', true);

				if(!isNaN(numDays)){
					var selectedDay = self.data.fields.birthDay.val();
					self.data.fields.birthDay.empty();
					for(var i=1; i<numDays+1; i++){
						self.data.fields.birthDay.append("<option value=\"" + i + "\">" + i + "</option>");
					}
					self.data.fields.birthDay.prop('required',true);
					self.data.fields.birthMonth.Selecta('refresh');
					self.data.fields.birthDay.Selecta('refresh');
				}
			}
		});

        self.data.fields.locations.on("selecta-change", function(e){
            $('.s-cf_preferredlocation').addClass('show');
        });

		// Validation
		self.data.fields.name.on("invalid", function(e) {
			e.target.setCustomValidity("Please fill out this field");
		});

		self.data.fields.locations.on("invalid", function(e){
			e.target.setCustomValidity("Please choose one or more locations");
		});

		self.data.fields.email.on("invalid", function(e) {
			e.target.setCustomValidity("Please enter a valid email address");
		});

		// Clear field's error message if its value has changed
		for(i in self.data.fields){
			self.data.fields[i].on("change", function(e){
				e.target.setCustomValidity("");
			});
		}

		self.getDataIfValid = function()
        {
			var invalid = [];

			var temp = self.data.fields.email.val();
			if(!temp){ // TODO: validate email
				invalid.push('email');
			}

			if (!invalid.length) {
				var names = self.data.fields.name.val().split(" ");

				var data = {
					"email": self.data.fields.email.val(),
					"firstName": names[0],
					"lastName": names.length > 1 ? names.slice(-1).toString() : null,
					"birthMonth": self.data.fields.birthMonth.val(),
					"birthDay": self.data.fields.birthDay.val(),
					"locationIDs": self.data.fields.locations.val().join(","),
					"preferredLocation": self.data.fields.preferredLocation.val(),
					"over_21": self.data.fields.over21Checkbox.prop("checked") ? "Yes" : "No",
				};

				return {
					"success": true,
					"data": data
				};
			}
			return {
				"success": false,
				"invalid": invalid
			};
		}

		self.data.$form.on("submit", function(e){
			var $form = $(this);

			if (frc.utilities.validateForm($form)) {
				var result = self.getDataIfValid();
				if (result.data) {
					$('.form').addClass("busy");

					// Make Emma API call with the validated form data as the payload
					frc.api.core.ebites.signup(result.data, function(response) {
						$('.form').attr("data-submitted", true).removeClass("busy");
						if (response && response.data && response.data.status == 'o') {
							$('.form').addClass('opted-out');
						}

						$(frc).trigger("ebitesformsubmitted", result.data);
					});
				}
			}
			e.preventDefault();
		});

		// $(window).on('load', function() {
//			$('section.form').addClass('in-view');
		$(window).trigger('ebites-form-loaded', $('section.form'));
		// });

	}

	self.init();
	return self;

}
